import { styled } from '@mui/material';

import { Paper } from '../paper';
import { ToggleButton, ToggleButtonGroup, toggleButtonGroupClasses } from '../toggle-button';

export interface FilterButtonItem {
  value: string;
  label: string;
}

export interface FilterButtonGroupProps {
  items: FilterButtonItem[];
  value: string;
  onChange: (value: string) => void;
}

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(1),
    border: 0,
    borderRadius: theme.shape.rounded(1.5),
    [`&.${toggleButtonGroupClasses.selected}`]: {
      boxShadow: '0px 1px 3px 0px #343A401A',
      backgroundColor: theme.palette.common.white,
    },
  },
}));

export default function FilterButtonGroup(props: Readonly<FilterButtonGroupProps>) {
  const { items, value, onChange } = props;

  return (
    <Paper
      elevation={0}
      sx={(theme) => ({
        display: 'flex',
        flexWrap: 'wrap',
        width: 'fit-content',
        borderRadius: theme.shape.rounded(2),
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.grey[100]}`,
      })}
    >
      <StyledToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) {
            onChange(newValue);
          }
        }}
        size='small'
      >
        {items.map((item) => (
          <ToggleButton
            key={item.value}
            value={item.value}
            sx={(theme) => ({ paddingX: theme.spacing(4) })}
          >
            {item.label}
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </Paper>
  );
}
